import { DraftFutureLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { productView } from './leg-product';
import { futureExpirationView } from './future-leg-expiration';
import { actionView } from './leg-action';
import { ratioView } from './leg-ratio';
import { priceView } from './leg-price';
import instrumentView from './future-leg-instrument';
import greeksView from './future-leg-greeks';
import { quantityView } from './leg-quantity';

export function futureLegView(
  leg: DraftFutureLeg,
  instruments: UnifiedInstruments['futureInstruments'],
  isCustomStrategy: boolean,
  isOrderBook: boolean,
) {
  const { index } = leg;
  const kind = 'FUTURE' as const;
  const product = productView(leg, isOrderBook);
  const action = actionView(leg.action, leg.productCode, leg.isHedge);
  const instrumentKind = 'Future';
  const expiration = futureExpirationView(leg.expiration, instruments);
  const price = priceView(leg.price, leg.isHedge, leg.productCode);
  const ratio = ratioView(leg.ratio, leg.productCode, isOrderBook);
  const quantity = quantityView(
    leg.quantity,
    leg.productCode,
    isOrderBook,
    leg.expiration != null,
  );
  const [instrument, instrument_id] = instrumentView(
    leg.expiration,
    instruments,
  );
  const greeks = greeksView(leg.expiration, instruments);

  const isValid =
    expiration.isValid &&
    ratio.isValid &&
    price.isValid &&
    (isOrderBook || quantity.isValid);
  const isRemovable = isCustomStrategy || leg.isHedge;

  return {
    index,
    kind,
    product,
    action,
    instrumentKind,
    expiration,
    price,
    ratio,
    isValid,
    isRemovable,
    instrument,
    instrument_id,
    greeks,
    quantity,
    isHedge: leg.isHedge,
  };
}
